<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-btn
      outlined
      :disabled="packages.length == 0"
      @click="exportExcel"
      width="150"
      class="mt-1 text-capitalize"
      color="primary"
    >
      <v-icon class="me-1">mdi-export</v-icon>Export
    </v-btn>
    <div v-show="false">
      <v-data-table
        id="printPackages"
        hide-default-footer
        :headers="headers"
        :items-per-page="-1"
        :items="packages"
        class="elevation-1 mt-6"
      >

      <template v-slot:item.index="{ item }">
        {{ item.index }}
      </template>
      <template v-slot:item.totalCustomers="{ item }">
        {{ item.totalCustomers }}
      </template>
      <template v-slot:item.totalIncome="{ item }">
        {{ item.totalIncome.toFixed(2) }}KD
      </template>
      <template v-slot:item.titleEn="{ item }">
          {{ item.titleEn }}
        <!-- </v-row> -->
      </template>
    
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
// import moment from "moment";
export default {
  components: {},
  props: {
    packages: {
      required: true,
    },
    headers: {
      required: true,
    },
  },
  methods: {
    exportExcel() {
      Utils.htmlToExcel("printPackages", "Packages", false);
    },
  },
};
</script>